import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { styled } from '../styles/stitches.config';

const SkinCorrectingBlock = (props) => {

    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "skincorrectingbenefits" }) {
              childImageSharp {
                  gatsbyImageData
              }
            }
          }
        `
    );

    const image = getImage(data.allFile);

    const GridSection = styled('section', {
        display: 'flex',
        '@bp1': {
            padding: '80px 20px',
        },
        '@bp2': {
            padding: '120px 20px',
        },
        '@bp4': {
            padding: '120px 100px 120px 85px',
        },
    });

    const GridInternalWrapper = styled('div', {
        display: 'grid',
        gridTemplateColumns: '3fr 4fr',
        '@bp1': {
            gridTemplateColumns: '1fr',
            gap: '40px',
        },
        '@bp2': {
            gap: '40px',
        },
        '@bp3': {
            gap: '85px! important',
        },
        '@bp4': {
            gap: '40px',
        },
        '& .header': {
            '& h3': {
                fontSize: '18px',
                lineHeight: '29px',
                marginBottom: '12px',
                fontFamily: '$lato',
                textTransform: 'uppercase',
                letterSpacing: '.1em',
            },
            '& h2': {
                fontSize: '44px',
                lineHeight: '58px',
                marginBottom: '36px',
                fontFamily: '$default',
            },
        },
        '& .benefits': {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '40px',
            '@bp1': {
                gridTemplateColumns: '1fr',
            },
            '& div': {
                display: 'flex',
                flexFlow: 'column',
                flex: '1 0 50%',
                '& h4': {
                    fontFamily: '$default',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    letterSpacing: '.15em',
                },
                '& p': {
                    fontFamily: '$lato',
                    color: '#585D6B',
                    fontSize: '18px',
                    lineHeight: '29px',

                }
            }
        }
    });

    return (
        <GridSection id={props.id}>
            <GridInternalWrapper>
                <div>
                    <div style={{ position: 'sticky', top: 0 }}>
                        <GatsbyImage image={image} alt={'blah'} />
                    </div>
                </div>
                <div>
                    <div className='header'>
                        <h3>One Gentle Step</h3>
                        <h2>7 skin-correcting benefits</h2>
                    </div>
                    <div className='benefits'>
                        <div>
                            <h4>1. Renewing</h4>
                            <p>Superstar active ingredients like Salicylic Acid, L-Lactic acid gently exfoliate, stimulate cellular renewal, refine and unclog pores to reveal a fresh complexion and improved texture.</p>
                        </div>
                        <div>
                            <h4>2. Brightening</h4>
                            <p>Powerhouse ingredient Niacinamide aka Vitamin B3 is combined with antioxidants to brighten skin, fade pigmentation and enhance overall luminosity.</p>
                        </div>
                        <div>
                            <h4>3. Hydrating</h4>
                            <p>Healing ingredients like Aloe Vera, Glycerin, Sodium Hyaluronate and Jojoba oil work together to provide multi-level hydration to restore comfort and suppleness.</p>
                        </div>
                        <div>
                            <h4>4. Energising</h4>
                            <p>Vital antioxidants like CoQ10 and plant-based Red Ginseng activate cell metabolism, providing energy for our skin cells to repair, regenerate and remove toxins for healthier skin cells.</p>
                        </div>
                        <div>
                            <h4>5. Firming</h4>
                            <p>Niacinamide, CoQ10 and Japanese Knotweed work together to boost our natural collagen production, improve elasticity and inhibit AGES (Advanced Glycation Endproducts) for firmer, smoother skin.</p>
                        </div>
                        <div>
                            <h4>6. Soothing</h4>
                            <p>Plant-based antioxidants like Chamomile, Green Tea, Red Ginseng and Ginkgo combined with skin-healing Allantoin deliver vitamins and nutrients to effectively calm redness, repair damage and defend against environmental stress.</p>
                        </div>
                        <div>
                            <h4>7. Restoring</h4>
                            <p>Essential skin identical ingredients like Ceramides, Amino Acids work together with Grape Seed oil to replenish skin, maintain and restore skin barrier health to improve moisture retention and prevent future skin issues.</p>
                        </div>
                    </div>
                </div>
            </GridInternalWrapper>
        </GridSection>
    )
}

export default SkinCorrectingBlock;
